<template>
    <div>
        <el-dialog
            v-model="dialogVisible" class="template-dialog" :modal="modal" :append-to-body="appendToBody"
            :show-close="false" :width="width" :close-on-click-modal="!modal" :close-on-press-escape="!modal"
        >
            <template #header>
                <div class="flex-left-rigth dialog-header">
                    <div class="title">
                        {{ title }}
                    </div>
                    <slot name="actions">
                    </slot>
                    <div class="flex-middle-x">
                        <div class="flex-middle-x log-out cursor-pointer" v-if="logOut" @click="exit">
                            <img src="../image/log-out.png" alt="">
                            <div class="log-out-text">
                                退出登录
                            </div>
                        </div>
                        <!-- 关闭按钮 -->
                        <img :src="close" alt="" class="close cursor-pointer" @click="handelCancel(true)">
                    </div>
                </div>
            </template>
            <!-- 插槽内容 -->
            <div class="content">
                <slot>
                </slot>
            </div>
            <!-- 底部按钮内容 -->
            <template #footer>
                <div>
                    <slot name="footer">
                    </slot>
                    <div class="dialog-footer">
                        <slot name="buttons-prefix">
                        </slot>
                        <el-button @click="handelCancel(false)" class="cancel-button" v-if="!noCancel">
                            {{ cancelTxt || "取消" }}
                        </el-button>
                        <template v-if="!props.noConfirm">
                            <lm-badge v-if="TypeTool.isNotEmtpy(props.confirmBadge)" :value="props.confirmBadge" >
                                <el-button
                                    v-if="!props.noConfirm"
                                    type="primary"
                                    class="confirm-button"
                                    :loading="confirmLoading"
                                    :disabled="confirmLoading"
                                    @click="handelConfirm"
                                >
                                    {{ confirmTxt || "确认" }}
                                </el-button>
                            </lm-badge>
                            <el-button
                                v-else
                                type="primary"
                                class="confirm-button"
                                :loading="confirmLoading"
                                :disabled="confirmLoading"
                                @click="handelConfirm"
                            >
                                {{ confirmTxt || "确认" }}
                            </el-button>
                        </template>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script lang="ts" setup>
import close from "@/assets/images/dialog-close.png";
import LmBadge from "@/components/lm-badge/index.vue";
import { useUserStore } from "@/stores/modules/user";
import TypeTool from "@/utils/TypeTool";

const userStore = useUserStore();
const router = useRouter();
const props = defineProps<{
    visible: boolean;
    title?: string;
    width?: string;
    cancelTxt?: string;
    logOut?: boolean;
    modal?: boolean;
    appendToBody?: boolean;
    confirmTxt?: string;
    noConfirm?: boolean;
    noCancel?: boolean;
    confirmBadge?: string;
    confirmLoading?: boolean;
    beforeConfirm?: () => Promise<boolean>,
    beforeCancel?: (close: boolean) => Promise<boolean>,
}>();

const emit = defineEmits(["update:visible", "cancel", "confirm"]);

const dialogVisible = ref(false) as any;

watch(() => props.visible, (val) => {
    dialogVisible.value = val;
});

watch(() => dialogVisible.value, (val) => {
    emit("update:visible", val);
});


const exit = async () => {
    // await logoutApi();
    userStore.clearUserInfo();
    localStorage.clear();
    router.push("/login");
    dialogVisible.value = false;
};


const handelCancel = async (close: boolean) => {
    if (props.confirmLoading) {
        return;
    }
    if (props.beforeCancel != null || props.beforeCancel != undefined) {
        if (!await props.beforeCancel(close)) {
            return;
        }
    }
    dialogVisible.value = false;
    emit("cancel", close);
};

const handelConfirm = async () => {
    if (props.confirmLoading) {
        return;
    }
    if (props.beforeConfirm != null || props.beforeConfirm != undefined) {
        if (!await props.beforeConfirm()) {
            return;
        }
    }
    dialogVisible.value = false;
    emit("confirm");
};

</script>


<style lang="scss" scoped>


    :deep(.el-dialog__header) {
        padding-bottom: 0;
    }

    .dialog-header {
        align-items: center;
        padding: 18px 24px;
        border-bottom: 0.5px solid #f2f2f2;

        .title {
            font-weight: 500;
            font-size: 18px;
            color: #1A1A1A;
            line-height: 26px;
        }

        .log-out {
            margin-right: 41px;

            img {
                width: 16px;
                height: 16px;
                display: block;
            }

            .log-out-text {
                font-weight: 400;
                font-size: 16px;
                color: $help-color;
                line-height: 25px;
            }
        }

        .close {
            width: 16px;
            height: 16px;
            display: block;
        }
    }

    .content {
        padding: 0 24px;
    }

    :deep(.el-dialog__footer) {
        padding: 10px;
        border-top: 0.5px solid #f2f2f2;
    }

    .dialog-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background: #FFFFFF;
        border-radius: 0px 0px 8px 8px;

        .cancel-button {
            min-width: 120px;
            height: 44px;
            border-radius: 21px;
            border: 1px solid #CCCCCC !important;
            font-weight: 400;
            font-size: 16px;
            color: #1A1A1A;
            line-height: 24px;
            box-sizing: border-box;
            padding: 0px 24px;

            &:hover {
                color: #1A1A1A;
                background: #fff;
            }
        }

        .confirm-button {
            min-width: 120px;
            padding: 0px 24px;
            height: 44px;
            background: $main-color;
            border-radius: 21px;
            font-weight: 400;
            font-size: 16px;
            color: #1A1A1A;
            line-height: 24px;
            box-sizing: border-box;
            border: none;

            &:hover {
                color: #1A1A1A;
                background: $main-color;
            }
        }

    }

</style>